import { Bet } from '../types/Bet';
import { MatchBetBreakdown } from '../types/MatchBetBreakdown';
import { apiGet, apiPost, apiPut } from './apiClient';

export interface CreateBetRequest {
  homeTeamScoreBet: number;
  awayTeamScoreBet: number;
  matchId: number;
  bettorId: string;
}

export interface UpdateBetRequest {
  id: number;
  homeTeamScoreBet: number;
  awayTeamScoreBet: number;
  matchId: number;
  bettorId: string;
}

export function getUserBets(userId: string): Promise<Bet[]> {
  return apiGet<Bet[]>(`/api/Bet/All/User/${userId}`);
}

export function getMatchBetBreakdown(
  matchId: number,
  leagueId: number
): Promise<MatchBetBreakdown> {
  return apiGet<MatchBetBreakdown>(`/api/Bet/Match/${matchId}/League/${leagueId}`);
}

export function createBet(body: CreateBetRequest): Promise<Bet> {
  return apiPost<Bet>('/api/Bet', body);
}

export function updateBet(id: number, body: UpdateBetRequest): Promise<void> {
  return apiPut(`/api/Bet/${id}`, body);
}
